import React from "react";
import {
  buildPriceReportScene,
  formatReportPrice,
  PRICE_REPORT_PT_TO_MM,
} from "./utils/priceReportLayout.js";
import "./ReportPriceSuggestions.css";

// La misma escena se dibuja como SVG acá y como texto/vectores nativos en jsPDF.
export default function ReportPriceSuggestions({
  prices = [],
  currency = "USD",
  onPriceChange,
  showEditControls = true,
}) {
  const { elements, cards } = buildPriceReportScene(prices, currency);
  const scale = 2; // Vista previa 640 px / página 320 mm.

  return (
    <div className="report-price-sheet">
      <svg
        className="report-price-sheet__art"
        viewBox="0 0 320 297"
        role="img"
        aria-label="Cuatro alternativas de precio incluidas en el informe"
      >
        {elements.map((element, index) => {
          if (element.type === "text") {
            return (
              <text
                key={index}
                x={element.x}
                y={element.y}
                fontSize={element.fontPt * PRICE_REPORT_PT_TO_MM}
                fontFamily="Helvetica, Arial, sans-serif"
                fontWeight={element.bold ? "bold" : "normal"}
                fill={element.color}
              >{element.value}</text>
            );
          }
          if (element.type === "circle") {
            return <circle key={index} cx={element.x} cy={element.y} r={element.radius} fill={element.fill} />;
          }
          return (
            <rect
              key={index}
              x={element.x}
              y={element.y}
              width={element.width}
              height={element.height}
              rx={element.radius}
              fill={element.fill}
              stroke={element.stroke || "none"}
              strokeWidth={0.3}
            />
          );
        })}
      </svg>
      {showEditControls && cards.map((card) => {
        const fontPx = card.fontPt * PRICE_REPORT_PT_TO_MM * scale;
        const prefix = `${currency} `;
        const displayValue = card.value === "" ? prefix : formatReportPrice(card.value, currency);
        return (
          <input
            key={card.key}
            type="text"
            inputMode="numeric"
            className="report-price-sheet__input"
            aria-label={`Precio ${card.label.toLowerCase()}`}
            aria-invalid={!(Number(card.value) > 0)}
            title={`Editar precio ${card.label.toLowerCase()}`}
            value={displayValue}
            onChange={(event) => {
              const raw = event.target.value.startsWith(prefix)
                ? event.target.value.slice(prefix.length)
                : event.target.value;
              const clean = raw.replace(/[.,\s]/g, "");
              if (/^\d{0,15}$/.test(clean)) onPriceChange(card.key, clean);
            }}
            onFocus={(event) => event.target.setSelectionRange(prefix.length, event.target.value.length)}
            style={{
              left: card.x * scale,
              top: card.y * scale - fontPx * 0.78,
              width: card.width * scale,
              height: fontPx * 1.2,
              fontSize: fontPx,
              "--card-fill": card.fill,
            }}
          />
        );
      })}
    </div>
  );
}
